"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreImportStoreConfigToJSON = exports.StoreImportStoreConfigFromJSONTyped = exports.StoreImportStoreConfigFromJSON = exports.instanceOfStoreImportStoreConfig = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoreImportStoreConfig interface.
 */
function instanceOfStoreImportStoreConfig(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreImportStoreConfig = instanceOfStoreImportStoreConfig;
function StoreImportStoreConfigFromJSON(json) {
    return StoreImportStoreConfigFromJSONTyped(json, false);
}
exports.StoreImportStoreConfigFromJSON = StoreImportStoreConfigFromJSON;
function StoreImportStoreConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'profits': !(0, runtime_1.exists)(json, 'profits') ? undefined : json['profits'],
        'bannerEnabled': !(0, runtime_1.exists)(json, 'banner_enabled') ? undefined : json['banner_enabled'],
        'hidePrices': !(0, runtime_1.exists)(json, 'hide_prices') ? undefined : json['hide_prices'],
        'accessRestriction': !(0, runtime_1.exists)(json, 'access_restriction') ? undefined : json['access_restriction'],
        'fulfillVia': !(0, runtime_1.exists)(json, 'fulfill_via') ? undefined : json['fulfill_via'],
        'showRecommendations': !(0, runtime_1.exists)(json, 'show_recommendations') ? undefined : json['show_recommendations'],
        'shippingDestinations': !(0, runtime_1.exists)(json, 'shipping_destinations') ? undefined : json['shipping_destinations'],
        'storeAccessCode': !(0, runtime_1.exists)(json, 'store_access_code') ? undefined : json['store_access_code'],
        'vouchers': !(0, runtime_1.exists)(json, 'vouchers') ? undefined : json['vouchers'],
    };
}
exports.StoreImportStoreConfigFromJSONTyped = StoreImportStoreConfigFromJSONTyped;
function StoreImportStoreConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'profits': value.profits,
        'banner_enabled': value.bannerEnabled,
        'hide_prices': value.hidePrices,
        'access_restriction': value.accessRestriction,
        'fulfill_via': value.fulfillVia,
        'show_recommendations': value.showRecommendations,
        'shipping_destinations': value.shippingDestinations,
        'store_access_code': value.storeAccessCode,
        'vouchers': value.vouchers,
    };
}
exports.StoreImportStoreConfigToJSON = StoreImportStoreConfigToJSON;
